// extracted by mini-css-extract-plugin
export var block1 = "index-module--block1--2dsug";
export var block2 = "index-module--block2--Ckgtj";
export var block3 = "index-module--block3--r-vK4";
export var circle = "index-module--circle--CrgDU";
export var ctaBlock = "index-module--ctaBlock--H7vJe";
export var dotWrapper = "index-module--dotWrapper--M65bE";
export var headerBlock = "index-module--headerBlock--rHIKq";
export var image = "index-module--image--8dGVg";
export var imageArea = "index-module--imageArea--tZZFB";
export var imageBlock = "index-module--imageBlock--TEG6k";
export var imageSubtitle = "index-module--imageSubtitle--KB9vS";
export var imageTitle = "index-module--imageTitle--PMn1o";
export var imageWrapper = "index-module--imageWrapper--Q21LG";
export var line1 = "index-module--line1--ykDuO";
export var line2 = "index-module--line2--hao4T";
export var line3 = "index-module--line3--SfzfH";
export var sensorTechnologyContainer = "index-module--sensorTechnologyContainer--WbZAy";
export var sensorTechnologyInnerContainer = "index-module--sensorTechnologyInnerContainer--qYmAc";
export var slickItemWrapper = "index-module--slickItemWrapper--5WUWV";
export var subtitleBlock = "index-module--subtitleBlock--g5aJ4";
export var titleBlock = "index-module--titleBlock--XpV2u";